import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */

  getall(id, params) {
    return backofficeService.Api().get('api/masjidImage', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getAllListAds(params) {
    console.log('params', params)
    return backofficeService.Api().get('api/masjidImage', {
        params
      })
      .then(response => response.data.data)
      .catch((error) => {
        throw error
      })
  },
  noTokenGetAllListAds(params) {
    console.log('params', params)
    return backofficeService.Api().get('noToken/masjidImage', {
        params
      })
      .then(response => response.data.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`api/masjidImage/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    console.log('resultpreosddd', data)
    return backofficeService.Api().post('api/masjidImage', {
        AdImage: data
      })
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`api/masjidImage/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`api/masjidImage/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}
